import { render, staticRenderFns } from "./NotificationFiles.vue?vue&type=template&id=6e164014&scoped=true"
import script from "./NotificationFiles.vue?vue&type=script&lang=js"
export * from "./NotificationFiles.vue?vue&type=script&lang=js"
import style0 from "./NotificationFiles.vue?vue&type=style&index=0&id=6e164014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e164014",
  null
  
)

export default component.exports